<template>
  <IQOS class="gap-row-xs" required :title="$t('workers.admin_bot.title')">
    <p class="v1-grey-10-color qrw-paragraph-md">
      {{ $t("workers.admin_bot.explain") }}
    </p>
    <div class="gap-column-lg">
      <img
        class="iqos-qrcode-image notif-qrcode"
        :src="qrCodeSrc"
        v-if="code"
      />

      <div class="telegram-status-block">
        <div class="qrcode-wrapper gap-row-xs">
          <div class="gap-column-xs">
            <div :class="isConnected ? 'green-5-color' : 'v1-grey-7-color'">
              <BaseIcon icon="telegram-bold" size="lg" />
            </div>
            <div class="gap-row-2xs"> 
              <div class="qrw-label-sm bold v1-grey-10-color">
                QRWaiter Business Bot
              </div>
              <div class="v1-grey-7-color" v-if="!isConnected">
                {{ $t("workers_table.bot_not_connected") }}
              </div>
              <div class="green-5-color qrw-paragraph-md" v-else>
                {{ $t("workers_table.bot_connected") }}
              </div>
            </div>
          </div>

          <div class="v1-grey-7-color qrw-paragraph-md">
            {{ $t("workers.admin_bot.scan") }}
          </div>
        </div>
      </div>

      <!-- <div>
        
      </div> -->
    </div>
    <div class="gap-row-1xs">
    <a
      href="https://t.me/QRWaiterBusinessBot"
      class="bot-link green-5-color qrw-paragraph-md"
      >@QRWaiterBusinessBot</a
    >
    <p class="qrw-paragraph-md">
      {{ $t("workers.admin_bot.authcode") }} {{ code }}
    </p>
    </div>

    <!-- <h3 class="onetimecode">
          
    </h3>-->
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import OwnersbotAPI from "@/api/ownersbot";

export default {
  data() {
    return {
      code: null,
    };
  },
  components: {
    IQOS,
  },
  mounted() {
    OwnersbotAPI.getOnetimeCode()
      .then((data) => {
        this.code = data.code;
      })
      .catch((error) => {
        //
      });
  },
  computed: {
    qrCodeSrc() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=168x168&data=https://t.me/QRWaiterBusinessBot?start=${this.code}`;
    },
    isConnected() {
      return !!this.$store.state.owner.ownersbot_id;
    },
  },
};
</script>

<style scoped>
.onetimecode {
  font-size: 3vh;

  color: #ededed;
}

.bot-link {
  margin-top: 1vh;
  display: block;
}

.qrcode-wrapper {
  display: flex;
}

.notif-qrcode {
  min-width: 160px;
  max-width: 160px;
  width: 160px;
  height: 160px;
  min-height: 160px;
  border-radius: 4px;
  border: 4px solid var(--white-color);
}

.status-block {
  margin-left: 2vh;

  align-self: center;
}

.telegram-status-block {
  display: flex;
  align-content: center;
  align-items: center;
}

.telegram-status-block p {
  padding: 0;
  margin: 0;
}

.telegram-status-block img {
  margin-right: 1.65vh;
}
</style>